// extracted by mini-css-extract-plugin
export default {"loading":"ProgressiveImg_loading__scIRr","loaded":"ProgressiveImg_loaded__7fbF3"};